import { useLoginData } from "component/common/loginData";
import Button from "component/ui/Button";
import FullPageLoader from "component/ui/fullPageLoader";
import PageHeading from "component/ui/PageHeading";
import { CurrencyFormat } from "helper/appConstant";
import {
  card_Details_Data,
  CARD_TYPE,
  CARDS_ENUMS,
  CARDS_NAVIGATION_ENUMS,
} from "helper/constant";
import { ChevronDown } from "lucide-react";
import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { CgProfile } from "react-icons/cg";
import { FaStar } from "react-icons/fa";
import { GrStreetView } from "react-icons/gr";
import { IoIosArrowDown } from "react-icons/io";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getEventDetails, getServiceDetails } from "store/slice/booking";
import {
  getDetailsByReferenceId,
  getGameOnCardDetail,
  getJoinRequestDetail,
  getVenueDetails,
} from "store/slice/profile";

const CardDetails = () => {
  const { type, id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const { eventDetailsData, serviceDetailsData } = useSelector(
    (state) => state.booking
  );
  const [cardDetailsData, setCardDetailsData] = useState(null);
  const {
    userProfileData,
    referenceIdDetailData,
    gameOnCardDetail,
    joinRequestDetail,
    venueDetailsData,
  } = useSelector((state) => state.profile);

  useEffect(() => {
    if (id) {
      setLoader(true);
      if (type == CARDS_NAVIGATION_ENUMS?.PSZ) {
        dispatch(getServiceDetails(id, setLoader));
      } else if (type == CARDS_NAVIGATION_ENUMS?.event) {
        dispatch(getEventDetails(id, setLoader));
      } else if (type == CARDS_NAVIGATION_ENUMS?.PCZ) {
        dispatch(getJoinRequestDetail(id, setLoader));
      } else if (type == CARDS_NAVIGATION_ENUMS?.PGZ) {
        dispatch(getGameOnCardDetail(id, setLoader));
      } else if (type == CARDS_NAVIGATION_ENUMS?.PVZ) {
        dispatch(getVenueDetails(id, setLoader));
      } else if (type == "card") {
        const request = { language: "en", referenceId: id };
        dispatch(getDetailsByReferenceId(request, setLoader));
      }
    }
  }, [id]);
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-8 px-4 relative overflow-hidden">
      {/* Animated Background Elements */}
      {loader && <FullPageLoader />}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200/30 rounded-full blur-3xl animate-pulse" />
        <div
          className="absolute bottom-20 right-10 w-96 h-96 bg-indigo-200/30 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: "1s" }}
        />
        <div
          className="absolute top-1/2 left-1/3 w-64 h-64 bg-purple-200/20 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: "2s" }}
        />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex gap-5 ">
          <PageHeading title="Card Details" />
        </div>

        <div className="space-y-8">
          {(type == CARDS_NAVIGATION_ENUMS?.PSZ
            ? serviceDetailsData
            : type == CARDS_NAVIGATION_ENUMS?.event
            ? eventDetailsData
            : type == CARDS_NAVIGATION_ENUMS?.PCZ
            ? joinRequestDetail
            : type == CARDS_NAVIGATION_ENUMS?.PGZ
            ? gameOnCardDetail
            : type == CARDS_NAVIGATION_ENUMS?.PVZ
            ? venueDetailsData
            : type == "card" && referenceIdDetailData) && (
            <Card
              type={type == "card" ? CARDS_NAVIGATION_ENUMS?.PVZ : type}
              item={
                type == CARDS_NAVIGATION_ENUMS?.PSZ
                  ? serviceDetailsData
                  : type == CARDS_NAVIGATION_ENUMS?.event
                  ? eventDetailsData
                  : type == CARDS_NAVIGATION_ENUMS?.PCZ
                  ? joinRequestDetail
                  : type == CARDS_NAVIGATION_ENUMS?.PGZ
                  ? gameOnCardDetail
                  : type == CARDS_NAVIGATION_ENUMS?.PVZ
                  ? venueDetailsData
                  : type == "card"
                  ? referenceIdDetailData
                  : ""
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

const Card = ({ item, type }) => {
  const navigate = useNavigate();
  const userData = useLoginData();
  console.log("Fff", item);
  return (
    <div
      className=""
      style={{
        animation: `fadeInUp 0.6s ease-out s backwards`,
      }}
    >
      {/* Card Header with Glassmorphism */}
      <div className="relative bg-brand-gradient md:p-4 p-3 rounded-t-lg overflow-hidden">
        <div className="group rounded-lg  transition-all  ">
          <div className="flex items-start md:space-x-4 space-x-2">
            <div className="relative">
              {item?.profileImageUrl ? (
                <img
                  src={item?.profileImageUrl}
                  alt={""}
                  className="md:w-12 md:h-12 w-8  rounded-2xl object-cover ring-2"
                  // style={{ borderColor: mainColor }}
                />
              ) : (
                <div className="md:w-12 md:h-12 w-8 flex justify-center items-center font-semibold text-white  rounded-2xl bg-highlight ring-2">
                  {item?.name && item?.name?.charAt(0)?.toUpperCase()}
                </div>
              )}
            </div>
            <div className="w-full flex justify-between">
              <div>
                <h3 className="text-md text-white text-lg font-semibold  line-clamp-2 w-full font-medium  ">
                  {item?.name}
                </h3>
                <Button
                  size="xs"
                  style={{ border: "1px solid white" }}
                  onClick={() => {
                    navigate(`/player-details/${item?.userId}`);
                  }}
                >
                  View Profile
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Card Body */}

      <div className="md:py-5 md:px-3 p-2 border bg-white">
        {item?.cardReferenceID && (
          <div className="flex justify-end mb-2" style={{ marginTop: "-1rem" }}>
            <div className="bg-brand-gradient text-sm font-semibold rounded-lg  w-fit px-3 py-1 text-white">
              ID: {item?.cardReferenceID}
            </div>
          </div>
        )}
        {/* service */}
        {type == "service" && (
          <div className="grid gap-4 mb-5">
            <div className="space-y-3">
              <div className="flex gap-4">
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">🎮</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        Games or Sport
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.category}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">👤</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        Crew/Association Name
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.crewOrAssocianname}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">🧰</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        Service Sought
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.serviceName}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Age & Gender Cards */}
              <div className="grid grid-cols-4 gap-3">
                <div className="border-2 border-blue-300 rounded-xl md:p-4 p-2 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="flex items-center gap-2 ">
                    <span className="md:text-2xl text-xl">👥</span>
                    <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                      Age Group
                    </p>
                  </div>
                  <p className="md:text-lg text-sm font-medium text-gray-800 md:pl-8">
                    {item?.ageGroup}
                  </p>
                </div>
                <div className="border-2 border-blue-300 rounded-xl md:p-4 p-2 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="flex items-center gap-2 ">
                    <span className="md:text-2xl text-xl">⚧</span>
                    <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                      Gender
                    </p>
                  </div>
                  <p className="md:text-lg text-sm font-medium text-gray-800 ms:pl-8">
                    {type == "service" ? item?.prefGender : item?.gender}
                  </p>
                </div>
                <div className="border-2 border-blue-300 rounded-xl md:p-4 p-2 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="flex items-center gap-2 ">
                    <span className="md:text-2xl text-xl">🔢</span>
                    <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                      Number Of Crew
                    </p>
                  </div>
                  <p className="md:text-lg text-sm font-medium text-gray-800 md:pl-8">
                    {item?.noOfCrew}
                  </p>
                </div>
                <div className="border-2 border-blue-300 rounded-xl md:p-4 p-2 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="flex items-center gap-2 ">
                    <span className="md:text-2xl text-xl">💰</span>
                    <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                      Budget
                    </p>
                  </div>
                  <p className="md:text-lg text-sm font-medium text-gray-800 ms:pl-8">
                    {CurrencyFormat(item?.budget)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* event */}
        {type == CARDS_NAVIGATION_ENUMS?.event && (
          <div className="grid md:grid-cols-2 gap-4 mb-5">
            <div className="space-y-3">
              <div className="relative border-2 border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                <div className="relative flex items-center gap-4">
                  <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                    <span className="md:text-3xl text-xl">🎮</span>
                  </div>
                  <div className="flex-1">
                    <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                      Games or Sport
                    </p>
                    <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                      {item?.category}
                    </p>
                  </div>
                </div>
              </div>

              {/* Age & Gender Cards */}
              <div className="grid grid-cols-2 gap-3">
                <div className="border-2 border-blue-300 rounded-xl md:p-4 p-2 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="flex items-center gap-2 ">
                    <span className="md:text-2xl text-xl">👥</span>
                    <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                      Age Group
                    </p>
                  </div>
                  <p className="md:text-lg text-sm font-medium text-gray-800 md:pl-8">
                    {item?.ageGroup}
                  </p>
                </div>
                <div className="border-2 border-blue-300 rounded-xl md:p-4 p-2 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="flex items-center gap-2 ">
                    <span className="md:text-2xl text-xl">⚧</span>
                    <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                      Gender
                    </p>
                  </div>
                  <p className="md:text-lg text-sm font-medium text-gray-800 ms:pl-8">
                    {type == "service" ? item?.prefGender : item?.gender}
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column - Fee Card */}
            <div className="border-2 border-blue-300 rounded-xl md:p-5 p-2 shadow-md hover:shadow-xl transition-all duration-300 flex flex-col justify-center items-center text-center">
              <span className="md:text-2xl text-xl mb-3">💰</span>
              <p className="text-sm font-medium opacity-90 uppercase tracking-wide mb-2">
                Entry Fee
              </p>
              <p className="md:text-4xl text-2xl md:font-bold font-semibold text-gray-800 md:mb-2">
                {CurrencyFormat(item?.eventFees)}
              </p>
              <div className="mt-3 px-4 py-2 bg-white/60 rounded-full">
                <p className="text-sm font-semibold text-gray-700">
                  Live booking availablity :
                  <span className="text-highlight">
                    {" "}
                    {item.live_availability ? "Yes" : "No"}
                  </span>
                </p>
              </div>
            </div>
          </div>
        )}
        {/* join */}
        {type == CARDS_NAVIGATION_ENUMS?.PCZ && (
          <div className="grid gap-4 mb-5">
            <div className="space-y-3">
              <div className="flex md:flex-row flex-col gap-4">
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">🎮</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        Games or Sport
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.category}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">👤</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        Club Name
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.clubName ? item?.clubName : "-"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">🧰</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        Skill Level
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.mySkillLevel}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* game on */}
        {type == CARDS_NAVIGATION_ENUMS?.PGZ && (
          <div className="grid gap-4 mb-5">
            <div className="space-y-3">
              <div className="flex gap-4">
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">🎮</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        Games or Sport
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.category}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">👤</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        Venue Name
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.venueName}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">🧰</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        Skills Required
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.skillsRequired}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Age & Gender Cards */}
              <div className="grid grid-cols-4 gap-3">
                <div className="border-2 border-blue-300 rounded-xl md:p-4 p-2 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="flex items-center gap-2 ">
                    <span className="md:text-2xl text-xl">👥</span>
                    <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                      Age Group
                    </p>
                  </div>
                  <p className="md:text-lg text-sm font-medium text-gray-800 md:pl-8">
                    {item?.ageGroup}
                  </p>
                </div>
                <div className="border-2 border-blue-300 rounded-xl md:p-4 p-2 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="flex items-center gap-2 ">
                    <span className="md:text-2xl text-xl">⚧</span>
                    <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                      Gender
                    </p>
                  </div>
                  <p className="md:text-lg text-sm font-medium text-gray-800 md:pl-8">
                    {item?.prefGender?.map((gender) => `${gender}, `)}
                  </p>
                </div>
                <div className="border-2 border-blue-300 rounded-xl md:p-4 p-2 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="border-b-2 pb-1">
                    <div className="flex items-center gap-2 ">
                      <span className="md:text-2xl text-xl">🔢</span>
                      <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                        Players Required
                      </p>
                    </div>
                    <p className="md:text-lg text-sm font-medium text-gray-800 md:pl-8">
                      {item?.noOfPlayers}
                    </p>
                  </div>
                  <div className="pt-1">
                    <div className="flex items-center gap-2 ">
                      <span className="text-xl">🚨</span>
                      <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                        Is it an emergency
                      </p>
                    </div>
                    <p className="md:text-lg text-sm font-medium text-gray-800 md:pl-8">
                      {item?.isItAnEmergency ? "Yes" : "No"}
                    </p>
                  </div>
                </div>
                <div className="border-2 border-blue-300 rounded-xl md:p-4 p-2 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="border-b-2 pb-1">
                    <div className="flex items-center gap-2 ">
                      <span className="md:text-2xl text-xl">💰</span>
                      <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                        Membership Fees
                      </p>
                    </div>
                    <p className="md:text-lg text-sm font-medium text-gray-800 md:pl-8">
                      {CurrencyFormat(item?.membershipFees)}
                    </p>
                  </div>
                  <div className="pt-1">
                    <div className="flex items-center gap-2 ">
                      <span className="text-xl">✅</span>
                      <p className="text-xs font-medium opacity-90 uppercase tracking-wide">
                        Booking Required
                      </p>
                    </div>
                    <p className="md:text-lg text-sm font-medium text-gray-800 md:pl-8">
                      {item?.isBookingRequired ? "Yes" : "No"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* venue */}
        {type == CARDS_NAVIGATION_ENUMS?.PVZ && (
          <div className="grid gap-4 mb-5">
            <div className="space-y-3">
              <div className="flex gap-4">
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">🎮</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        Games or Sport
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.category}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">👤</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        Venue Name
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.venueName}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="relative border-2 w-full border-blue-300 rounded-xl md:p-6 p-3 transition-all duration-300 overflow-hidden group">
                  <div className="relative flex items-center gap-4">
                    <div className="bg-white/20 backdrop-blur-md rounded-2xl p-2 shadow-lg">
                      <span className="md:text-3xl text-xl">🔢</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium text-black uppercase tracking-widest mb-1">
                        No.Of Player Attending
                      </p>
                      <p className="md:text-3xl text-xl font-medium text-black drop-shadow-lg">
                        {item?.noOfPlayreAttanding}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Timeline Section - Date & Contact */}
        <div className="border-2 border-blue-300 rounded-xl md:p-5 p-2 mb-5 shadow-md hover:shadow-xl transition-all duration-300">
          <div className="flex md:flex-row flex-col md:items-center justify-between gap-4">
            <div className="flex md:flex-row flex-col md:items-start items-center md:text-left text-center md:gap-4 gap-2 flex-1">
              <div className="bg-blue-100 rounded-full p-2">
                <span className=" text-xl">📅</span>
              </div>
              <div>
                <p className="text-xs font-medium opacity-90 uppercase tracking-wide mb-1">
                  {type != CARDS_NAVIGATION_ENUMS?.PCZ && "Start"} Date & Time
                </p>
                <p className="md:text-lg text-sm font-medium text-gray-800">
                  {type == CARDS_NAVIGATION_ENUMS?.PCZ
                    ? `${item?.clubRequestCardDate} ${item?.clubRequestCardTime}`
                    : item?.startDateAndTime}
                </p>
              </div>
            </div>

            <div className="h-12 w-px bg-blue-300 hidden md:block" />
            {(type == CARDS_NAVIGATION_ENUMS?.PSZ ||
              type == CARDS_NAVIGATION_ENUMS?.PGZ) && (
              <>
                <div className="flex md:flex-row flex-col md:items-start items-center md:text-left text-center md:gap-4 gap-2 flex-1">
                  <div className="bg-blue-100 rounded-full p-2">
                    <span className=" text-xl">📅</span>
                  </div>
                  <div>
                    <p className="text-xs font-medium opacity-90 uppercase tracking-wide mb-1">
                      End Date & Time
                    </p>
                    <p className="md:text-lg text-sm font-medium text-gray-800">
                      {item?.endDateAndTime}
                    </p>
                  </div>
                </div>

                <div className="h-12 w-px bg-blue-300 hidden md:block" />
              </>
            )}

            {item?.location?.address && (
              <>
                <div className="flex md:flex-row flex-col md:items-start items-center md:text-left text-center gap-4 flex-1">
                  <div className="bg-indigo-100 rounded-full p-2">
                    <span className="text-xl">📍</span>
                  </div>
                  <div>
                    <p className="text-xs font-medium opacity-90 uppercase tracking-wide mb-1">
                      Location
                    </p>
                    <p className="md:text-lg flex gap-2 text-sm font-medium text-gray-800">
                      {item?.location?.address}
                      {item?.location?.coordinates?.length > 0 && (
                        <a
                          href={`https://www.google.com/maps?q=${item?.location?.coordinates[1]},${item?.location?.coordinates[0]}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600"
                        >
                          <GrStreetView className="h-5 w-5 cursor-pointer text-highlight" />
                        </a>
                      )}
                    </p>
                  </div>
                </div>

                {type != CARDS_NAVIGATION_ENUMS?.PCZ &&
                  type != CARDS_NAVIGATION_ENUMS?.PGZ &&
                  type != CARDS_NAVIGATION_ENUMS?.PVZ && (
                    <div className="h-12 w-px bg-blue-300 hidden md:block" />
                  )}
              </>
            )}
            {type != CARDS_NAVIGATION_ENUMS?.PCZ &&
              type != CARDS_NAVIGATION_ENUMS?.PGZ &&
              type != CARDS_NAVIGATION_ENUMS?.PVZ && (
                <div className="flex md:flex-row flex-col md:items-start items-center md:text-left text-center gap-4 flex-1">
                  <div className="bg-blue-100 rounded-full p-2">
                    <span className="text-xl">📞</span>
                  </div>
                  <div>
                    <p className="text-xs font-medium opacity-90 uppercase tracking-wide mb-1">
                      Contact Number
                    </p>
                    <p className="md:text-lg text-sm font-medium text-gray-800">
                      + {type == "service" ? item?.contactNo : item?.phone}
                    </p>
                  </div>
                </div>
              )}
          </div>
        </div>

        {/* Description & Requirements in Expandable Sections */}
        <div className="flex md:flex-row flex-col items-stretch gap-5">
          {item?.description && (
            <ExpandableSection
              icon="📝"
              title="Description"
              content={item?.description}
              bgColor="bg-gradient-to-br from-slate-50 to-blue-50"
              borderColor="border-blue-300"
              textColor="text-highlight"
              className="md:w-1/2 w-full"
            />
          )}
          {type == CARDS_NAVIGATION_ENUMS?.PCZ && item?.achievements && (
            <ExpandableSection
              icon="✓"
              title="My Achievements"
              content={item?.achievements}
              bgColor="bg-gradient-to-br from-slate-50 to-blue-50"
              borderColor="border-blue-300"
              textColor="text-highlight"
              className="md:w-1/2 w-full"
            />
          )}
          {type == CARDS_NAVIGATION_ENUMS?.PVZ && item?.otherRequirements && (
            <ExpandableSection
              icon="✓"
              title="Other Requirements"
              content={item?.otherRequirements}
              bgColor="bg-gradient-to-br from-slate-50 to-blue-50"
              borderColor="border-blue-300"
              textColor="text-highlight"
              className="md:w-1/2 w-full"
            />
          )}
          {(type == "service"
            ? item?.yourOwnEquipment
            : item?.requirements) && (
            <ExpandableSection
              icon="✓"
              title="Requirements"
              content={
                type == "service" ? item?.yourOwnEquipment : item?.requirements
              }
              bgColor="bg-gradient-to-br from-blue-50 to-indigo-50"
              borderColor="border-blue-300"
              textColor="text-highlight"
              className="md:w-1/2 w-full"
            />
          )}
        </div>

        {/* Booked Slots */}
        {item?.slotDetails?.length > 0 && (
          <>
            <div className="mt-2 mb-5 flex items-center text-lg font-semibold text-slate-900 font-outfit">
              <span className="mr-3 h-5 w-1 rounded bg-gradient-to-b from-[#2bace2] to-[#1a8fc9]" />
              Booked Slots
            </div>

            <Accordion allowZeroExpanded className="border-none">
              <AccordionItem className="mb-3 overflow-hidden rounded-xl border-2 border-slate-200 bg-white transition hover:shadow-sm">
                <AccordionItemHeading>
                  <AccordionItemButton className="flex items-center justify-between p-3 bg-gradient-to-br from-slate-50 to-slate-100 hover:from-slate-100 hover:to-slate-200 transition">
                    <span className="font-semibold text-slate-700 capitalize">
                      {item?.slotDetails?.length > 0 &&
                        item?.slotDetails[0]?.arenaName}
                    </span>
                    <IoIosArrowDown className="text-xl text-[#2bace2] transition-transform" />
                  </AccordionItemButton>
                </AccordionItemHeading>

                <AccordionItemPanel className="p-5 animate-slideDown">
                  <div className="grid grid-cols-[repeat(auto-fill,minmax(130px,1fr))] gap-3">
                    {item?.slotDetails?.map((time, i) => (
                      <div
                        key={i}
                        className=" border-1 border-gray-200 px-4  text-center text-sm font-semibold text-gray-600 transition py-3 rounded-lg  bg-gray-200 text-black cursor-not-allowed"
                      >
                        {time.fromTime}-{time.toTime}
                      </div>
                    ))}
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </>
        )}
        {item?.joinPlayersData?.length > 0 && (
          <>
            <div className="mt-8 mb-5 flex items-center text-lg font-semibold text-slate-900 font-outfit">
              <span className="mr-3 h-5 w-1 rounded bg-gradient-to-b from-[#2bace2] to-[#1a8fc9]" />
              Assigned Users
            </div>

            <div className="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-4 max-sm:grid-cols-[repeat(auto-fill,minmax(140px,1fr))]">
              {item?.joinPlayersData?.map((player, index) => (
                <div
                  key={index}
                  className="relative flex flex-col items-center gap-2 rounded-xl border-2 border-slate-200 bg-gradient-to-br from-slate-50 to-slate-100 p-4 transition-all hover:border-[#2bace2] hover:shadow-lg"
                >
                  {player?.profileImageUrl ? (
                    <img
                      src={player?.profileImageUrl}
                      alt={player?.name}
                      className="h-14 w-14 rounded-full border-4 border-white object-cover shadow-md"
                    />
                  ) : (
                    <div className="h-14 w-14 rounded-full bg-gradient-to-br from-[#2bace2] to-[#1a8fc9] flex items-center justify-center text-white text-xl font-semibold shadow-md capitalize">
                      {player?.name?.[0]}
                    </div>
                  )}

                  <span className="text-sm font-medium text-slate-700 text-center">
                    {player?.name}
                  </span>
                  {player?.isGameCreater && (
                    <div className="absolute top-2 right-2">
                      <FaStar className="h-6 w-6 text-yellow-500" />
                    </div>
                  )}
                  {player?.id === userData?.id ? (
                    <span className="rounded-full bg-brand-gradient px-3 py-1 text-[10px] font-semibold text-white">
                      You
                    </span>
                  ) : (
                    <CgProfile
                      onClick={() => navigate(`/player-details/${player?.id}`)}
                      className="h-8 w-8 text-[#2bace2] cursor-pointer transition hover:scale-110 hover:text-[#1a8fc9]"
                    />
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const ExpandableSection = ({
  icon,
  title,
  content,
  bgColor,
  borderColor,
  textColor,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div
      className={`${bgColor} ${className} max-h-36 rounded-xl border-2 ${borderColor} overflow-hidden transition-all duration-300 hover:shadow-lg`}
    >
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-4 flex items-center justify-between hover:bg-white/50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <span className="text-xl">{icon}</span>
          <h4 className={`text-base font-semibold ${textColor}`}>{title}</h4>
        </div>
        <span
          className={`text-xl transition-transform duration-300 ${
            isExpanded ? "rotate-180" : ""
          }`}
        >
          <ChevronDown />
        </span>
      </button>
      {isExpanded && (
        <div className="px-4 pb-4 animate-fadeIn">
          <p className={`text-sm text-gray-500 leading-relaxed line-clamp-3`}>
            {content}
          </p>
        </div>
      )}
    </div>
  );
};

export default CardDetails;
